var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageCell"},[_c('img',{staticClass:"img",attrs:{"src":_vm.row.head}})])
}
var staticRenderFns = []

export { render, staticRenderFns }